import { jsx as _jsx } from "react/jsx-runtime";
import { GroupedTokenHeader, NetworkRouteSelectItemDisplay } from "../Routes";
export const CollapsableHeader = ({ item, direction, hideTokenImages, hideBalances, }) => {
    const groupedByToken = item.type === "grouped_token";
    return groupedByToken ? (_jsx(GroupedTokenHeader, { item: item, direction: direction, hideTokenImages: hideTokenImages, hideBalances: hideBalances })) : (_jsx(NetworkRouteSelectItemDisplay, { item: item.route, selected: false, direction: direction, hideTokenImages: hideTokenImages, hideBalances: hideBalances }));
};
